import URLSearchParams from '@ungap/url-search-params';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React from 'react';

import { MARKETO } from '../constants';

const setUTMCookie = () => {
  if (typeof window === 'undefined') {
    return;
  }

  // Store utm data for later submission (assumes they will be utm_[something]:
  // eslint-disable-next-line no-undef
  var urlParams = new URLSearchParams(window.location.search);

  let cookieVal = '';
  for (let key of urlParams.keys()) {
    if (key.indexOf('utm_') === 0 || key.indexOf('refer') === 0) {
      let utmKey = key;
      if (key.indexOf('utm_') === 0) {
        utmKey = `${utmKey}_2`;
      }
      cookieVal += `${utmKey}=${urlParams.get(key)}|`;
    }
  }
  if (cookieVal) {
    Cookies.set(MARKETO.UTM_COOKIE, cookieVal.slice(0, -1));
  }
};

const checkConsent = () => {
  let allowRefCookie = false;
  const oneTrust = Cookies.get('OptanonConsent');
  if (!oneTrust) return true;
  if (oneTrust) {
    const vals = oneTrust.split('&');
    let groups;
    for (let i = 0; i < vals.length; i++) {
      if (vals[i].indexOf('groups=') > -1) {
        groups = vals[i].split('=')[1];
        break;
      }
    }
    if (!groups) return false;
    let groupArr = groups.split(',');
    // 2:1 is group 2 (analytics), 1 = true
    if (groupArr.find((g) => g === '2:1')) {
      allowRefCookie = true;
    }
  }

  return allowRefCookie;
};

const setParamsCookie = () => {
  if (typeof window === 'undefined') {
    return;
  }

  //if (!checkConsent()) return;
  // Store utm data for later submission
  // eslint-disable-next-line no-undef
  var urlParams = new URLSearchParams(window.location.search);

  for (let key of urlParams.keys()) {
    Cookies.set(key, urlParams.get(key));
  }

  const referrer = Cookies.get('_fs_oreferrer');
  if (!referrer) {
    Cookies.set('_fs_oreferrer', window.document.referrer);
  }
};

/**
 * Wrapper to collect incoming marketing data
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const MarketingStore = (props) => {
  setParamsCookie();
  setUTMCookie();
  return <>{props.children}</>;
};

MarketingStore.propTypes = {
  children: PropTypes.any,
};

export default MarketingStore;
